import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import MobilePageChangeEffectLayer from '../../@common/Layer/MobilePageChangeEffectLayer';
import MobilePageNavigationButton from '../../@common/PageNavigationButton/Mobile';
import { currentPageAtom } from '../../../store/index.atom';
import { PdfViewerRedirect } from '../../PdfViewer/index.types';
import MobileIntro from '../../@common/Intro/Mobile';
import RootLayout from '../../@common/RootLayout';
import MobilePageWrapper from '../../@common/PageWrapper/Mobile';
import MobilePageNavigation from '../../@common/PageNavigationDrawer/Mobile';
import MobilePage from '../../@common/Viewer/Mobile';
import MobileAnnotationLayer from '../../@common/Layer/OneOnOneAnnotationLayer/Mobile';

interface Props {
  translateKoToEn: (item: string) => string;
  file: Omit<PdfViewerRedirect, 'isDownloadEnabled'>;
}

const MobilePdfPreview = ({ translateKoToEn, file }: Props) => {
  const currentPage = useAtomValue(currentPageAtom);

  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const { thumnail, pages } = file;

  const isNextPageButtonDisabled = currentPage >= thumnail?.length;

  /** NOTE: 렌더링하는 곳에서 user agent 체킹하므로 landscape만 체크 */
  const isMobileLandscape = useMediaQuery({
    query: '(orientation: landscape)',
  });

  return (
    <RootLayout mode="mobile">
      <MobileIntro translateKoToEn={translateKoToEn} />

      <MobilePageWrapper totalPage={pages}>
        <MobilePage
          thumnails={thumnail?.map((value) => {
            if (value?.thumnail) {
              return {
                src: value.thumnail,
                imageSources: value.imageSources,
              };
            }
            return null;
          })}
          isMobileLandscape={isMobileLandscape}
        />
        <MobilePageChangeEffectLayer />
        <MobilePageNavigationButton
          totalPage={Number(pages)}
          isNextPageButtonDisabled={isNextPageButtonDisabled}
          isMoveCtaFormPageRequirements={true}
          openDrawer={() => setIsMobileDrawerOpen(true)}
          isMobileLandscape={isMobileLandscape}
        />

        {thumnail && <MobileAnnotationLayer thumnail={thumnail} />}
      </MobilePageWrapper>

      <MobilePageNavigation
        translateKoToEn={translateKoToEn}
        pages={thumnail}
        setIsMobileDrawerOpen={setIsMobileDrawerOpen}
        isMobileDrawerOpen={isMobileDrawerOpen}
        isMobileLandscape={isMobileLandscape}
      />
    </RootLayout>
  );
};

export default MobilePdfPreview;
